import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs";
import { ContactForm } from "./model/contactForm";
import { AbstractLrmService } from "../common/abstractlrmService";

@Injectable()
export class ContactService extends AbstractLrmService {
  //Create constructor to get Http instance
  constructor(http: Http) {
    super(http);
  }

  sendMessageToContact(form: ContactForm) {
    let endPoint: string = "/contact";
    return this.postRequest(endPoint, form);
  }
}



// WEBPACK FOOTER //
// /Neptune/buildsJenkins/lrm_grandPublic/LRM-GP/LrGrandPublic/src/main/LRM-web/src/app/contact/contact.service.ts